const Weights = {
  normal: 'normal',
  semibold: 600,
  bold: 700,
};

export default Weights;
